var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPattern = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 762,
    height: 164,
    viewBox: "0 0 762 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_412_6788)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_412_6788",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 870,
    height: 167
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M870 0H0V167H870V0Z",
    fill: "url(#paint0_radial_412_6788)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_412_6788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.796875 55.551C-0.771991 44.9687 3.70711 27.2152 33.7917 27.2401C63.8763 27.2152 68.3554 44.9687 68.3803 55.551C68.3554 66.1333 63.8763 83.8867 33.7917 83.8618C3.73199 83.8867 -0.771991 66.1333 -0.796875 55.551Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.657 55.551C137.682 44.9687 142.161 27.2152 172.246 27.2401C202.33 27.2152 206.81 44.9687 206.834 55.551C206.81 66.1333 202.33 83.8867 172.246 83.8618C142.161 83.8867 137.657 66.1333 137.657 55.551Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.7 55.551C310.725 44.9687 315.204 27.2152 345.289 27.2401C375.373 27.2152 379.852 44.9687 379.877 55.551C379.852 66.1333 375.373 83.8867 345.289 83.8618C315.204 83.8867 310.725 66.1333 310.7 55.551Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.044 83.9614C72.9592 83.9863 68.4801 66.2329 68.4552 55.6506C68.4801 45.0683 72.9592 27.3148 103.044 27.3397V83.9614Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.657 83.9614C107.572 83.9863 103.093 66.2329 103.068 55.6506C103.093 45.0683 107.572 27.3148 137.657 27.3397V83.9614Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.472 83.9614C211.388 83.9863 206.909 66.2329 206.884 55.6506C206.909 45.0683 211.388 27.3148 241.472 27.3397V83.9614Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.087 83.9614C246.002 83.9863 241.523 66.2329 241.498 55.6506C241.523 45.0683 246.002 27.3148 276.087 27.3397V83.9614Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.7 83.9614C280.615 83.9863 276.136 66.2329 276.111 55.6506C276.136 45.0683 280.615 27.3148 310.7 27.3397V83.9614Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.448 112.222C241.473 101.64 245.952 83.8867 276.037 83.9116C306.121 83.8867 310.601 101.64 310.625 112.222C310.601 122.805 306.121 140.558 276.037 140.533C245.952 140.558 241.473 122.805 241.448 112.222Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.608 112.222C137.632 101.64 142.112 83.8867 172.196 83.9116C202.281 83.8867 206.76 101.64 206.785 112.222C206.76 122.805 202.281 140.558 172.196 140.533C142.136 140.558 137.632 122.805 137.608 112.222Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.675 112.222C310.7 101.64 315.179 83.8867 345.263 83.9116C375.348 83.8867 379.827 101.64 379.852 112.222C379.827 122.805 375.348 140.558 345.263 140.533C315.179 140.558 310.675 122.805 310.675 112.222Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4054 112.222C68.4303 101.64 72.9094 83.8867 102.994 83.9116C133.079 83.8867 137.558 101.64 137.583 112.222C137.558 122.805 133.079 140.558 102.994 140.533C72.9094 140.558 68.4054 122.805 68.4054 112.222Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.448 140.633C211.363 140.658 206.884 122.904 206.859 112.322C206.884 101.74 211.363 83.9864 241.448 84.0113V140.633Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7917 140.633C3.73199 140.658 -0.771991 122.904 -0.796875 112.322C-0.771991 101.74 3.70711 83.9864 33.7917 84.0113V140.633Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.405 140.633C38.3204 140.658 33.8413 122.904 33.8164 112.322C33.8413 101.74 38.3204 83.9864 68.405 84.0113V140.633Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.81 169.193C206.834 179.775 211.314 197.529 241.398 197.504C271.483 197.529 275.962 179.775 275.987 169.193C275.962 158.61 271.483 140.857 241.398 140.882C211.314 140.857 206.81 158.61 206.81 169.193Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.012 169.193C276.036 179.775 280.516 197.529 310.6 197.504C340.685 197.529 345.164 179.775 345.189 169.193C345.164 158.61 340.685 140.857 310.6 140.882C280.54 140.857 276.036 158.61 276.012 169.193Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4054 169.193C68.4303 179.775 72.9094 197.529 102.994 197.504C133.079 197.529 137.558 179.775 137.583 169.193C137.558 158.61 133.079 140.857 102.994 140.882C72.9094 140.857 68.4054 158.61 68.4054 169.193Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35.3105 169.193C-35.2857 179.775 -30.8066 197.529 -0.721958 197.504C29.3626 197.529 33.8417 179.775 33.8666 169.193C33.8417 158.61 29.3626 140.857 -0.721958 140.882C-30.8066 140.857 -35.2857 158.61 -35.3105 169.193Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.777 140.782C349.692 140.757 345.213 158.511 345.188 169.093C345.213 179.675 349.692 197.429 379.777 197.404V140.782Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4304 140.782C38.3458 140.757 33.8667 158.511 33.8418 169.093C33.8667 179.675 38.3458 197.429 68.4304 197.404V140.782Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7668 27.2402C3.7071 27.2651 -0.796875 9.51165 -0.796875 -1.07068",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.019 -1.17029C103.019 9.43694 98.515 27.1904 68.4304 27.1406C38.3458 27.1655 33.8667 9.41204 33.8418 -1.17029",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.81 -1.17029C206.785 9.41204 202.306 27.1655 172.221 27.1406C142.137 27.1655 137.658 9.41204 137.633 -1.17029",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.877 -1.17029C379.852 9.41204 375.373 27.1655 345.289 27.1406C315.204 27.1655 310.725 9.41204 310.7 -1.17029",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.657 27.2402C107.572 27.2651 103.093 9.51165 103.068 -1.07068",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.7 27.2402C280.615 27.2651 276.136 9.51165 276.111 -1.07068",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.81 -1.19519C206.834 9.38714 211.314 27.1406 241.398 27.1157C271.458 27.1406 275.962 9.38714 275.962 -1.19519",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.146 140.782C142.062 140.757 137.583 158.511 137.558 169.093C137.583 179.675 142.062 197.429 172.146 197.404V140.782Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.759 140.782C176.675 140.757 172.196 158.511 172.171 169.093C172.196 179.675 176.675 197.429 206.759 197.404V140.782Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.203 55.551C380.228 44.9687 384.707 27.2152 414.792 27.2401C444.876 27.2152 449.355 44.9687 449.38 55.551C449.355 66.1333 444.876 83.8867 414.792 83.8618C384.732 83.8867 380.228 66.1333 380.203 55.551Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.657 55.551C518.682 44.9687 523.161 27.2152 553.246 27.2401C583.33 27.2152 587.81 44.9687 587.834 55.551C587.81 66.1333 583.33 83.8867 553.246 83.8618C523.161 83.8867 518.657 66.1333 518.657 55.551Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.7 55.551C691.725 44.9687 696.204 27.2152 726.289 27.2401C756.373 27.2152 760.852 44.9687 760.877 55.551C760.852 66.1333 756.373 83.8867 726.289 83.8618C696.204 83.8867 691.725 66.1333 691.7 55.551Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.044 83.9614C453.959 83.9863 449.48 66.2329 449.455 55.6506C449.48 45.0683 453.959 27.3148 484.044 27.3397V83.9614Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.657 83.9614C488.572 83.9863 484.093 66.2329 484.068 55.6506C484.093 45.0683 488.572 27.3148 518.657 27.3397V83.9614Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.472 83.9614C592.388 83.9863 587.909 66.2329 587.884 55.6506C587.909 45.0683 592.388 27.3148 622.472 27.3397V83.9614Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.087 83.9614C627.002 83.9863 622.523 66.2329 622.498 55.6506C622.523 45.0683 627.002 27.3148 657.087 27.3397V83.9614Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.7 83.9614C661.615 83.9863 657.136 66.2329 657.111 55.6506C657.136 45.0683 661.615 27.3148 691.7 27.3397V83.9614Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.448 112.222C622.473 101.64 626.952 83.8867 657.037 83.9116C687.121 83.8867 691.601 101.64 691.625 112.222C691.601 122.805 687.121 140.558 657.037 140.533C626.952 140.558 622.473 122.805 622.448 112.222Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.608 112.222C518.632 101.64 523.112 83.8867 553.196 83.9116C583.281 83.8867 587.76 101.64 587.785 112.222C587.76 122.805 583.281 140.558 553.196 140.533C523.136 140.558 518.632 122.805 518.608 112.222Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.675 112.222C691.7 101.64 696.179 83.8867 726.263 83.9116C756.348 83.8867 760.827 101.64 760.852 112.222C760.827 122.805 756.348 140.558 726.263 140.533C696.179 140.558 691.675 122.805 691.675 112.222Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.405 112.222C449.43 101.64 453.909 83.8867 483.994 83.9116C514.079 83.8867 518.558 101.64 518.583 112.222C518.558 122.805 514.079 140.558 483.994 140.533C453.909 140.558 449.405 122.805 449.405 112.222Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.448 140.633C592.363 140.658 587.884 122.904 587.859 112.322C587.884 101.74 592.363 83.9864 622.448 84.0113V140.633Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.792 140.633C384.732 140.658 380.228 122.904 380.203 112.322C380.228 101.74 384.707 83.9864 414.792 84.0113V140.633Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.405 140.633C419.32 140.658 414.841 122.904 414.816 112.322C414.841 101.74 419.32 83.9864 449.405 84.0113V140.633Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.81 169.193C587.834 179.775 592.314 197.529 622.398 197.504C652.483 197.529 656.962 179.775 656.987 169.193C656.962 158.61 652.483 140.857 622.398 140.882C592.314 140.857 587.81 158.61 587.81 169.193Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.012 169.193C657.036 179.775 661.516 197.529 691.6 197.504C721.685 197.529 726.164 179.775 726.189 169.193C726.164 158.61 721.685 140.857 691.6 140.882C661.54 140.857 657.036 158.61 657.012 169.193Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.405 169.193C449.43 179.775 453.909 197.529 483.994 197.504C514.079 197.529 518.558 179.775 518.583 169.193C518.558 158.61 514.079 140.857 483.994 140.882C453.909 140.857 449.405 158.61 449.405 169.193Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.689 169.193C345.714 179.775 350.193 197.529 380.278 197.504C410.363 197.529 414.842 179.775 414.867 169.193C414.842 158.61 410.363 140.857 380.278 140.882C350.193 140.857 345.714 158.61 345.689 169.193Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.777 140.782C730.692 140.757 726.213 158.511 726.188 169.093C726.213 179.675 730.692 197.429 760.777 197.404V140.782Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.43 140.782C419.346 140.757 414.867 158.511 414.842 169.093C414.867 179.675 419.346 197.429 449.43 197.404V140.782Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.767 27.2402C384.707 27.2651 380.203 9.51165 380.203 -1.07068",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.019 -1.17029C484.019 9.43694 479.515 27.1904 449.43 27.1406C419.346 27.1655 414.867 9.41204 414.842 -1.17029",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.81 -1.17029C587.785 9.41204 583.306 27.1655 553.221 27.1406C523.137 27.1655 518.658 9.41204 518.633 -1.17029",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.877 -1.17029C760.852 9.41204 756.373 27.1655 726.289 27.1406C696.204 27.1655 691.725 9.41204 691.7 -1.17029",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.657 27.2402C488.572 27.2651 484.093 9.51165 484.068 -1.07068",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.7 27.2402C661.615 27.2651 657.136 9.51165 657.111 -1.07068",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.81 -1.19519C587.834 9.38714 592.314 27.1406 622.398 27.1157C652.458 27.1406 656.962 9.38714 656.962 -1.19519",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.146 140.782C523.062 140.757 518.583 158.511 518.558 169.093C518.583 179.675 523.062 197.429 553.146 197.404V140.782Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.759 140.782C557.675 140.757 553.196 158.511 553.171 169.093C553.196 179.675 557.675 197.429 587.759 197.404V140.782Z",
    stroke: "#C7AAFA",
    strokeWidth: 0.934,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_412_6788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.338 156.314C294.271 158.732 302.336 161.547 307.149 162.671C315.381 168.134 327.143 175.552 337.017 175.552C357.436 175.552 378.907 151.884 388.039 136.663C395.257 124.634 406.716 107.334 402.519 92.1196C400.996 86.5976 401.132 80.8288 399.347 75.2951C396.312 65.8872 392.319 56.5499 387.902 47.7141C378.332 28.5734 366.717 5.55666 347.773 -6.0689C341.094 -10.1673 331.904 -13.3752 324.468 -15.3086C314.521 -17.8948 304.557 -22.0341 294.337 -23.0312C280.744 -24.3575 264.753 -25.1105 251.864 -19.8594C242.258 -15.9458 232.571 -12.8855 228.352 -3.24185C223.762 7.25029 222.548 17.7228 225.939 29.028C231.391 47.202 247.705 56.5605 258.828 70.8132C264.261 77.775 271.236 84.6866 275.514 92.4643C278.928 98.6717 279.976 104.91 281.719 111.633C283.998 120.422 283.127 129.871 285.512 138.456C286.677 142.651 286.232 147.045 287.442 151.281C288.077 153.503 291.032 154.683 292.338 156.314Z",
    fill: "#1914FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_f_412_6788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1964 96.8463C45.0061 95.0393 37.6708 94.2169 33.4312 94.2402C25.3023 91.0081 13.7847 86.7489 5.65702 88.9267C-11.151 93.4303 -22.965 120.034 -26.7137 136.11C-29.6765 148.816 -34.8262 167.327 -27.605 180.458C-24.9841 185.224 -23.6684 190.584 -20.8292 195.303C-16.0022 203.325 -10.4037 211.071 -4.57998 218.261C8.03576 233.834 23.2938 252.538 41.7656 259.101C48.2776 261.414 56.6367 262.351 63.236 262.497C72.0636 262.693 81.2904 264.319 89.9495 262.987C101.467 261.214 114.816 258.382 124.125 250.688C131.063 244.954 138.279 239.99 139.364 230.15C140.545 219.443 138.952 209.5 133.362 199.803C124.375 184.214 108.63 179.166 95.9457 168.451C89.75 163.217 82.2976 158.37 76.8512 152.127C72.5045 147.145 70.097 141.613 66.9979 135.786C62.9464 128.168 61.324 119.246 57.2362 111.841C55.2385 108.222 54.5166 104.063 52.472 100.417C51.3994 98.5042 48.6745 98.0658 47.1964 96.8463Z",
    fill: "#7579FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter2_f_412_6788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.878 228.153C177.871 230.622 187.895 231.746 193.689 231.714C204.798 236.131 220.539 241.952 231.646 238.976C254.616 232.821 270.761 196.465 275.885 174.494C279.934 157.13 286.971 131.833 277.103 113.888C273.521 107.374 271.723 100.049 267.843 93.6005C261.246 82.6364 253.595 72.0504 245.636 62.2256C228.395 40.9425 207.543 15.3815 182.299 6.41284C173.4 3.25111 161.976 1.97094 152.957 1.77105C140.893 1.50366 128.284 -0.719351 116.45 1.10212C100.711 3.52481 82.467 7.39414 69.7454 17.909C60.2638 25.7459 50.4021 32.5298 48.9189 45.9778C47.3052 60.6091 49.4821 74.1981 57.1219 87.4502C69.4035 108.754 90.9207 115.653 108.256 130.296C116.723 137.449 126.907 144.073 134.351 152.604C140.291 159.413 143.581 166.973 147.816 174.937C153.353 185.348 155.57 197.541 161.157 207.661C163.887 212.607 164.874 218.29 167.668 223.273C169.134 225.887 172.857 226.486 174.878 228.153Z",
    fill: "#7F39FA"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter3_f_412_6788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748.338 156.314C750.271 158.732 758.336 161.547 763.149 162.671C771.381 168.135 783.143 175.552 793.017 175.552C813.436 175.552 834.907 151.884 844.039 136.663C851.257 124.634 862.716 107.334 858.519 92.1196C856.996 86.5977 857.132 80.8288 855.347 75.2952C852.312 65.8873 848.319 56.5499 843.902 47.7142C834.332 28.5735 822.717 5.55673 803.773 -6.06884C797.094 -10.1672 787.904 -13.3751 780.468 -15.3085C770.521 -17.8947 760.557 -22.0341 750.337 -23.0312C736.744 -24.3574 720.753 -25.1104 707.864 -19.8594C698.258 -15.9457 688.571 -12.8854 684.352 -3.24179C679.762 7.25035 678.548 17.7229 681.939 29.028C687.391 47.2021 703.705 56.5606 714.828 70.8133C720.261 77.775 727.236 84.6867 731.514 92.4644C734.928 98.6717 735.976 104.91 737.719 111.633C739.998 120.422 739.127 129.872 741.512 138.456C742.677 142.651 742.232 147.045 743.442 151.281C744.077 153.503 747.032 154.683 748.338 156.314Z",
    fill: "#1914FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter4_f_412_6788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.196 96.8463C501.006 95.0393 493.671 94.2169 489.431 94.2402C481.302 91.0081 469.785 86.7489 461.657 88.9267C444.849 93.4303 433.035 120.034 429.286 136.11C426.324 148.816 421.174 167.327 428.395 180.458C431.016 185.224 432.332 190.584 435.171 195.303C439.998 203.325 445.596 211.071 451.42 218.261C464.036 233.834 479.294 252.538 497.766 259.101C504.278 261.414 512.637 262.351 519.236 262.497C528.064 262.693 537.29 264.319 545.949 262.987C557.467 261.214 570.816 258.382 580.125 250.688C587.063 244.954 594.279 239.99 595.364 230.15C596.545 219.443 594.952 209.5 589.362 199.803C580.375 184.214 564.63 179.166 551.946 168.451C545.75 163.217 538.298 158.37 532.851 152.127C528.504 147.145 526.097 141.613 522.998 135.786C518.946 128.168 517.324 119.246 513.236 111.841C511.239 108.222 510.517 104.063 508.472 100.417C507.399 98.5042 504.675 98.0658 503.196 96.8463Z",
    fill: "#7579FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter5_f_412_6788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M630.878 228.153C633.871 230.622 643.895 231.746 649.689 231.714C660.798 236.131 676.539 241.952 687.646 238.976C710.616 232.821 726.761 196.465 731.885 174.494C735.934 157.13 742.971 131.833 733.103 113.888C729.521 107.374 727.723 100.049 723.843 93.6005C717.246 82.6364 709.595 72.0504 701.636 62.2256C684.395 40.9425 663.543 15.3815 638.299 6.41284C629.4 3.25111 617.976 1.97094 608.957 1.77105C596.893 1.50366 584.284 -0.719351 572.45 1.10212C556.711 3.52481 538.467 7.39414 525.745 17.909C516.264 25.7459 506.402 32.5298 504.919 45.9778C503.305 60.6091 505.482 74.1981 513.122 87.4502C525.403 108.754 546.921 115.653 564.256 130.296C572.723 137.449 582.907 144.073 590.351 152.604C596.291 159.413 599.581 166.973 603.816 174.937C609.353 185.348 611.57 197.541 617.157 207.661C619.887 212.607 620.874 218.29 623.668 223.273C625.134 225.887 628.857 226.486 630.878 228.153Z",
    fill: "#7F39FA"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_412_6788",
    x: -16,
    y: -264,
    width: 659.418,
    height: 679.552,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 120,
    result: "effect1_foregroundBlur_412_6788"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_412_6788",
    x: -271.278,
    y: -151.669,
    width: 651.008,
    height: 655.175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 120,
    result: "effect1_foregroundBlur_412_6788"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_412_6788",
    x: -191.581,
    y: -239.609,
    width: 713.703,
    height: 719.398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 120,
    result: "effect1_foregroundBlur_412_6788"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_412_6788",
    x: 440,
    y: -264,
    width: 659.418,
    height: 679.552,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 120,
    result: "effect1_foregroundBlur_412_6788"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_412_6788",
    x: 184.722,
    y: -151.669,
    width: 651.008,
    height: 655.175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 120,
    result: "effect1_foregroundBlur_412_6788"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_412_6788",
    x: 264.419,
    y: -239.609,
    width: 713.703,
    height: 719.398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 120,
    result: "effect1_foregroundBlur_412_6788"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_412_6788",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(435 83.5) rotate(90) scale(83.5 1284.98)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_412_6788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 762,
    height: 164,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPattern);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pattern.1a83f09acc16c5d7bff69beacbc1a858.svg";